import { useEffect, useRef } from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

export default function DetailDrawer({ title, subtitle, onClose, children }) {
  const returnFocusRef = useRef(typeof document === "undefined" ? null : document.activeElement);
  useEffect(() => () => returnFocusRef.current?.focus?.(), []);
  return (
    <Sheet open onOpenChange={(open) => { if (!open) onClose(); }}>
      <SheetContent
        side="right"
        data-testid="detail-drawer"
        onCloseAutoFocus={(event) => {
          event.preventDefault();
          returnFocusRef.current?.focus?.();
        }}
        className="flex h-full w-full max-w-lg flex-col gap-0 border-sm-ink/10 bg-white p-0 text-sm-ink sm:max-w-lg"
      >
        <SheetHeader className="border-b border-sm-ink/10 px-5 py-4 pr-14 text-left">
          <SheetTitle className="truncate font-display text-lg font-bold text-sm-ink">{title}</SheetTitle>
          <SheetDescription className={`mt-1 text-xs text-sm-muted ${subtitle ? "" : "sr-only"}`}>
            {subtitle || "Record details"}
          </SheetDescription>
        </SheetHeader>
        <div className="min-h-0 flex-1 overflow-y-auto p-5">{children}</div>
      </SheetContent>
    </Sheet>
  );
}
